import type { SxProps, Theme } from '@mui/material/styles'
import { alpha } from '@mui/material/styles'
import { darkGrey } from '@/core/theme/colors.ts'
import { globalCssVars } from '@/core/theme/GlobalCssVars.ts'

export const sharedButtonStyles = {
  borderRadius: '0.375rem',
  paddingLeft: '11px',
  paddingRight: '11px',
}

export function accentBlackWhiteButtonStyles(theme: Theme): Record<string, unknown> {
  return {
    background: theme.palette.mode == 'light' ? darkGrey[150] : theme.palette.text.primary,
    '& .MuiTypography-root': {
      color: theme.palette.mode == 'light' ? '#ffffff' : darkGrey[50],
    },
    // background:
    //   theme.palette.mode == 'light' ? theme.palette.primary.main : theme.palette.text.primary,
    // '& .MuiTypography-root': {
    //   color: theme.palette.mode == 'light' ? theme.palette.text.primary : darkGrey[50],
    // },
  }
}

export function dialogDeleteButtonSx(theme: Theme) {
  return {
    ...sharedButtonStyles,
    backgroundColor:
      theme.palette.mode === 'light' ? theme.palette.error.light : theme.palette.background.default,
    color: theme.palette.mode === 'light' ? '#ffffff' : theme.palette.error.light,
    // border: `1px solid ${theme.palette.error.main}`,
    '&:hover': {
      backgroundColor:
        theme.palette.mode === 'light'
          ? theme.palette.error.dark
          : theme.palette.background.default,
      border: `1px solid ${theme.palette.error.dark}`,
      color: theme.palette.mode === 'light' ? '#ffffff' : theme.palette.error.dark,
    },
    '&.Mui-focusVisible': {
      boxShadow: `0 0 0 3px ${theme.palette.error.light}`,
      border: `1px solid ${theme.palette.error.main}`,
    },
  }
}

export function deleteButtonSx(theme: Theme): Record<string, unknown> {
  return {
    ...sharedButtonStyles,
    color: theme.palette.error.main,
    '&:hover': {
      border: `1px solid ${theme.palette.error.main}`,
      borderColor: theme.palette.error.dark,
      color: theme.palette.error.dark,
      backgroundColor: alpha(theme.palette.error.main, 0.04),
    },
  }
}

export const coloredSubmitButtonSxConfig = {
  fontSize: 14,
}

export function coloredSubmitButtonSx(theme: Theme) {
  return {
    ...sharedButtonStyles,
    backgroundColor: theme.palette.primary.light,
    border: `solid 2px ${theme.palette.text.primary}`,
    fontSize: coloredSubmitButtonSxConfig.fontSize,
    borderRadius: globalCssVars.radius5,
    // px: 1,
    py: '3px',
    // width: '95px',
    // height: '32px',
    '&:hover': {
      borderColor: theme.palette.secondary.main,
    },
  }
}
